// Per-article badge — surfaces pipeline review state and the editor-add marker.
const PIPELINE_LABELS = {
  approved: null,
  needs_review: { label: 'Needs review', cls: 'bg-yellow-500 text-white' },
  compliance_blocked: { label: 'Compliance', cls: 'bg-hxd-warn text-white' },
  auto_failed: { label: 'Removed', cls: 'bg-hxd-muted text-white' },
};

export default function ArticleStatusBadge({ status, editorPromoted }) {
  const pipeline = PIPELINE_LABELS[status];

  return (
    <span className="inline-flex items-center gap-1.5">
      {editorPromoted && (
        <span className="bg-hxd-orange-soft text-hxd-orange border border-hxd-orange font-display text-[9px] font-bold uppercase tracking-display-sm px-1.5 py-0.5 rounded-[2px]">
          Editor add
        </span>
      )}
      {pipeline && (
        <span
          className={`${pipeline.cls} font-display text-[9px] font-bold uppercase tracking-display-sm px-1.5 py-0.5 rounded-[2px]`}
        >
          {pipeline.label}
        </span>
      )}
    </span>
  );
}
